"use client";

import { useEffect, useState } from "react";
import { Eye, Users } from "lucide-react";

export function DropSocialProof({ dropId }: { dropId: number }) {
  const [counts, setCounts] = useState<{ entries: number; watching: number } | null>(null);

  useEffect(() => {
    fetch(`/api/drops/${dropId}/entries`, { cache: "no-store" })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (data && typeof data.entries === "number") setCounts(data);
      })
      .catch(() => {});
  }, [dropId]);

  if (!counts) return null;
  const total = counts.entries + counts.watching;
  if (total === 0) return null;

  return (
    <div className="flex flex-wrap items-center justify-center gap-4 text-[10px] tracking-widest uppercase">
      {counts.watching > 0 && (
        <span className="text-muted-foreground flex items-center gap-1.5">
          <Eye className="h-3 w-3" />
          {counts.watching} watching
        </span>
      )}
      {counts.entries > 0 && (
        <span className="text-muted-foreground flex items-center gap-1.5">
          <Users className="h-3 w-3" />
          {counts.entries} joined
        </span>
      )}
    </div>
  );
}
